<template>
  <fullscreen-modal :visible.sync="visible" :title="'编辑报单'" :close-on-click-modal="false" @close="handleClose">
    <div class="edit-declaration-modal">
      <el-form :model="info" :rules="rules" ref="infoForm" label-width="120px">
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>商户报单信息:</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="付款人姓名" prop="customName">
                <el-input v-model="info.customName" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="付款人手机号" prop="customMobile">
                <el-input v-model="info.customMobile" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="现场对接人姓名" prop="region">
                <el-input v-model="info.region" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="现场对接人电话" prop="contactMobile">
                <el-input v-model="info.contactMobile" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="施工地址(区/县)" prop="customAddress">
                <el-input v-model="info.customAddress" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出货形式" prop="appointmentType">
                <el-input v-model="info.appointmentType" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="装饰公司" prop="introducer">
                <el-input v-model="info.introducer" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="户型" prop="houseType">
                <el-input v-model="info.houseType" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="业务员" prop="salesperson">
                <el-input v-model="info.salesperson" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="进场时间" prop="entranceTime">
                <el-date-picker v-model="info.entranceTime" type="date" placeholder="选择预计进场时间"
                  @change="handleEntranceTimeChange" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="备注" prop="remarks">
                <el-input type="textarea" v-model="info.remarks" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="施工工艺" prop="installationForm">
                <el-input v-model="info.installationForm" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <div class="btn-group">
              <el-button type="danger" size="small" @click="handleClose"
                icon="el-icon-circle-close-outline">取消</el-button>
              <el-button type="primary" size="small" @click="submit"
                icon="el-icon-circle-check-outline">保存修改</el-button>
            </div>
          </el-row>
          <!-- <el-form-item label="面积明细" prop="areaConfig">
            <el-table :data="info.areaConfig" style="width: 100%" border>
              <el-table-column prop="name" label="名称" width="180">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" />
                </template>
</el-table-column>
<el-table-column prop="length" label="长度(m)" width="220">
  <template slot-scope="scope">
                  <el-input-number v-model="scope.row.length" :precision="2" :step="0.1" :min="0"
                    @change="calculateArea(scope.row)" />
                </template>
</el-table-column>
<el-table-column prop="width" label="宽度(m)" width="220">
  <template slot-scope="scope">
                  <el-input-number v-model="scope.row.width" :precision="2" :step="0.1" :min="0"
                    @change="calculateArea(scope.row)" />
                </template>
</el-table-column>
<el-table-column prop="area" label="面积(㎡)" width="220">
  <template slot-scope="scope">
                  <el-input-number v-model="scope.row.area" :precision="2" :step="0.1" disabled :min="0" />
                </template>
</el-table-column>
<el-table-column prop="productName" label="商品名称" width="220">
  <template slot-scope="scope">
                  <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
                </template>
</el-table-column>
<el-table-column label="操作" width="220">
  <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="removeAreaItem(scope.$index)">删除</el-button>
                </template>
</el-table-column>
</el-table>
<el-button type="primary" icon="el-icon-plus" @click="addAreaItem">添加</el-button>
</el-form-item>
<el-form-item label="商品列表" prop="selectedGoods">
  <el-table :data="selectedGoods" style="width: 100%" border>
    <el-table-column prop="goodsName" label="商品名称" />
    <el-table-column prop="num" label="数量" />
  </el-table>
</el-form-item> -->
        </el-card>
      </el-form>
    </div>
  </fullscreen-modal>
</template>

<script>
import {
  getMerchantOrder,
  editMerchantOrder,
  getAreaConfigById,
  getGoodList,
} from "@/api/work/pipeline/merchants";
import FullscreenModal from "./fullscreen-modal.vue";

export default {
  name: "EditDeclarationModal",
  components: {
    FullscreenModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      info: {
        region: "",
        customAddress: "",
        houseType: "",
        installationType: "",
        installationForm: "",
        remove: "",
        area: "",
        payType: "",
        measureTime: null,
        declarationDate: null,
        entranceTime: null,
        salesperson: "",
        customName: "",
        customMobile: "",
        remarks: "",
        introducer: "",
      },
      selectedGoods: [],
      rules: {
        customAddress: [
          { required: true, message: "请输入施工地址(区/县)", trigger: "blur" },
        ],
        houseType: [{ required: true, message: "请输入户型", trigger: "blur" }],
        entranceTime: [
          { required: true, message: "请选择进场时间", trigger: "change" },
        ],
        customName: [
          { required: true, message: "请输入付款人姓名", trigger: "blur" },
        ],
        customMobile: [
          { required: true, message: "请输入付款人手机号", trigger: "blur" },
        ],
        region: [{ required: true, message: "请输入现场对接人姓名", trigger: "blur" }],
        contactMobile: [{ required: true, message: "请输入现场对接人电话", trigger: "blur" }],
      },
    };
  },
  watch: {
    visible(val) {
      if (val && this.id) {
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      this.resetData();
      this.getMerchantOrderData();
    },
    resetData() {
      this.info = {
        region: "",
        customAddress: "",
        houseType: "",
        installationType: "",
        installationForm: "",
        remove: "",
        area: "",
        payType: "",
        measureTime: null,
        declarationDate: null,
        entranceTime: null,
        salesperson: "",
        customName: "",
        customMobile: "",
        remarks: "",
        introducer: "",
      };
      this.selectedGoods = [];
      if (this.$refs.infoForm) {
        this.$refs.infoForm.resetFields();
      }
    },
    getMerchantOrderData() {
      getMerchantOrder(this.id).then((res) => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = {
            ...this.info,
            ...data,
          };
          if (data.list && data.list.length > 0) {
            this.processSelectedGoods(data.list);
          } else {
            getGoodList(this.id).then((res) => {
              if (res.code === "200") {
                let selectedGoods = JSON.parse(res.data);
                selectedGoods.forEach((goods) => {
                  if (goods.goodsId) {
                    let existingGoods = this.selectedGoods.find(
                      (g) => g.goodsId === goods.goodsId
                    );
                    if (existingGoods) {
                      existingGoods.num += goods.num;
                    } else {
                      this.selectedGoods.push(goods);
                    }
                  }
                });
              }
            });
          }
          this.getAreaConfig();
        }
      });
    },
    getAreaConfig() {
      getAreaConfigById(this.id).then((res) => {
        if (res.code == "200") {
          const areaData = JSON.parse(res.data);
          if (!this.info.areaConfig) {
            this.info.areaConfig = [];
          }
          this.info.areaConfig = areaData || [];
        }
      });
    },
    processSelectedGoods(selectedGoods) {
      selectedGoods.forEach((g) => {
        this.selectedGoods.push({
          goodsId: g.goodsId,
          goodsName: g.goodsName,
          num: g.num,
        });
      });
    },
    handleEntranceTimeChange(value) {
      this.info.entranceTime = value ? new Date(value).getTime() : null;
    },
    addAreaItem() {
      this.info.areaConfig.push({
        name: "",
        length: 0,
        width: 0,
        area: 0,
        declarationId: this.id,
        sort: this.info.areaConfig.length + 1,
      });
    },
    removeAreaItem(index) {
      this.info.areaConfig.splice(index, 1);
      this.info.areaConfig.forEach((item, i) => {
        item.sort = i + 1;
      });
    },
    calculateArea(row) {
      if (row.length && row.width) {
        row.area = Number((row.length * row.width).toFixed(2));
      } else {
        row.area = 0;
      }
    },
    submit() {
      this.$refs.infoForm.validate((valid) => {
        if (valid) {
          const submitData = {
            ...this.info
          };
          editMerchantOrder(submitData).then((res) => {
            console.log('edit-declaration-modal.vue ~ line: 306 ~ res ->', res);
            if (res.code == "200") {
              this.$message.success("修改成功");
              this.$emit("success");
              this.handleClose();
            } else {
              console.log('edit-declaration-modal.vue ~ line: 312 ~ res.message ->', res.message);
              this.$message.error("修改失败");
            }
          });
        } else {
          this.$message.error("请填写完整信息");
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-declaration-modal {
  min-height: 100%;
}

.card {
  margin-bottom: 20px;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-group {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
}
</style>
